/**
 * @callback EBContext.modules.Modal.callback
 * @param {String|Boolean} resp Response from invoked modal - `Boolean` if it is confirm, `true` if it is an alert or `String` if it is a prompt
 */
 
EBContext.instances.modalWindow = EBContext.instances.modalWindow || {};
EBContext.instances.modalBar = EBContext.instances.modalBar || {};
EBContext.instances.responsiveCollapse = EBContext.instances.responsiveCollapse || {};

/**
 * Namespace for basic modal popups
 * @class ModalWindow
 * @memberof EBContext.modules
 * @param {String} message Message to be displayed in the modal window
 * @param {EBContext.modules.Modal.callback} [callback] Callback that is called on submit of modal window
 * @param {Object} [options] object that merges into default options defining style, structure, controls and behavior of modal window
 */
EBContext.modules.ModalWindow = function (message, callback, options) {
	this.options = EBContext.utils.extendObj(false, {
		heading: EBContext.utils.text.getHeading(message),
		modal: true, //nelze zav��t kliknut�m mimo
		fade: true,	//p�echod p�i zobrazen�/skryti
		content: null, //obsah popup okna - [string] v�. header/footer, nadpisu, formu a tla��tek (pokud se nep�ed� cel� DOM okna v options.popupElement)
		centered: true, //vertik�ln� popup na obrazovce vycentrovat (horizont�ln� centrovan� je v�dy)
		contentClass: '', //dal�� t��dy elementu .modal-content (pokud se nep�ed� cel� DOM okna v options.popupElement)
		/* Tla��tka pro v�choz� typy popupu - alert, confirm, prompt - (pokud se nep�ed� cel� DOM okna v options.popupElement ani obsah okna v options.content) */
		btnEsc: {
			show: false,
			text: '',
			title: EBContext.resource('CLOSE'),
			class: 'btn-close'
		},
		btnOK: {
			text: EBContext.resource('ACCEPT'),
			title: EBContext.resource('ACCEPT'),
			class: 'btn btn-block d-md-inline w-md-auto float-right btn-success mt-2 text-truncate',
			order: 1,
			value: true,
			idPrefix: 'btnOK'
		},
		btnCancel: {
			text: EBContext.resource('CANCEL'), //'Zav��t',
			title: EBContext.resource('CANCEL'), //'Zav��t',
			class: 'btn btn-block d-md-inline w-md-auto float-left btn-danger mt-2 text-truncate',
			order: 2,
			value: false,
			idPrefix: 'btnCancel'
		},
		btnDefaults: {
			show: true, text: '', title: '', attr: '', class: 'btn btn-block d-md-inline w-md-auto float-right btn-primary mt-2 text-truncate',
			order: 1, value: 2, idPrefix: 'btn'
		},
		moreButtons: [],
		inputPrompt: {
			show: false,
			type: 'text',
			value: '',
			placeholder: '',
			title: EBContext.resource('ENTER_VALUE'), //'Zadejte hodnotu',
			attr: '',
			class: 'form-control'
		},
		closeOnSubmit: true, //zav��t popup po odesl�n� (popup defaultn� bez validace - zde lze kv�li validaci p�et�it)
		enableEscapeKey: true, //@TODO
		popupElement: null, //DOM popup okna nebo string/template ze kter�ho se DOM vygeneruje
		templates: null, //�ablony pro generov�n� popup DOM z options.popupElement
		variables: null, //prom�nn� pro generov�n� popup DOM z options.popupElement
		onShown: null,	//callback pro bootstrap.modal po zobrazen� popup okna
		modalId: null,	//ID popup okna pro pozd�j�� referencov�n� (jinak se vygeneruje n�hodn�)
		callback: function (response, modal) { //callback v�choz�ho formul��e; response - [string] promptu, [boolean] confirmu, [true] u alertu
			console.log(self.id + ': ' + response, modal);
		},
		disposable: false, //po zav�en� odebrat z DOM str�nky (pokud se nep�ed� cel� DOM okna v options.popupElement)
		scrollable: false
	}, options);

	this.callback = callback || this.options.callback;
	this.order = Object.keys(EBContext.instances.modalWindow).length;
	this.uid = 'w' + new Date().valueOf();
	this.id = this.options.modalId || 'modalWindow_' + this.uid;
	this.path = 'EBContext.instances.modalWindow.' + this.uid;
	EBContext.instances.modalWindow[this.uid] = this;
	this.close = function(dispose){
		if (self.modalObj) {
			self.modalObj.hide();
			if(dispose && self.modalObj._element) self.modalObj.dispose();
		}
		if(dispose || !self.modalObj){ //??
			self.modalObj = null;
			delete EBContext.instances.modalWindow[self.uid];
		}
	};
	this.open = function(){
		if('function' === typeof self.options.failedToShowCallback){
			this.checkShownTimeout = setTimeout(()=>{
				this.options.failedToShowCallback(self.modalEl);
			});
		} else {
			this.checkShownTimeout = 0;
		}
		document.body.appendChild(self.modalEl);
		self.modalObj.show();
	};
	var self = this;
	this.submitForm = function (form) {
		var formData = EBContext.utils.serializeForm(form, true);
		var resp = null;
		if (formData.hasOwnProperty('response_string')) {
			if (formData.response_boolean !== 'false') resp = formData.response_string;
		} else if(formData.hasOwnProperty('response_number')) {
			resp=parseFloat(formData.response_number);
		} else if(formData.hasOwnProperty('response_boolean')) {
			resp=(formData.response_boolean!=='false');
		} else if (formData.hasOwnProperty('btnOK')) {
			resp = true;
		} else {
			resp = false;
		}
		if(self.options.closeOnSubmit){
			self.close();
		}
		return self.callback(resp, self);
	};
	
	var modalDOM = self.options.popupElement;
	if(modalDOM instanceof HTMLElement) this.parentEl = self.options.popupElement.parentElement;
	if(typeof modalDOM === String){
		modalDOM = (self.options.templates || self.options.variables ? EBContext.utils.template(modalDOM, self.options.templates, self.options.variables) : EBContext.utils.createDOM(modalDOM));
	}
	else if(!modalDOM) {
		buttonsArr = [self.options.btnOK,self.options.btnCancel].concat(self.options.moreButtons).sort((a,b)=>(a.order<b.order ? -1 : (a.order>b.order ? 1 : 0)));
		buttonsArr.forEach(btn=>{btn.valueType = btn.valueType || typeof btn.value});
		modalDOM = EBContext.utils.createDOM(
			'<div class="modal' + (self.options.fade ? ' fade' : '') + '" tabindex="-1" disposable id="' + self.id + '" role="dialog">' +
			'<div class="modal-dialog' + (self.options.centered ? ' modal-dialog-centered' : '' ) + (self.options.scrollable ? ' modal-dialog-scrollable' : '' ) + '" role="document">' +
			'<div class="modal-content' + (self.options.contentClass ? ' ' + self.options.contentClass : '') + '">' +
			(!self.options.content ?
				'<form action="0" onsubmit="' + self.path + '.submitForm(this); return false;">' +
				'<div class="modal-header">' +
				'<h5 class="modal-title">' + self.options.heading + '</h5>' +
				(self.options.btnEsc.show ? '<button type="button" class="' + self.options.btnEsc.class + '" data-bs-dismiss="modal" aria-label="' + self.options.btnEsc.title + '"><span aria-hidden="true">' + self.options.btnEsc.text + '</span></button>' : '') +
				'</div>' +
				'<div class="modal-body">' +
				'<p>' + message + '</p>' +
				(self.options.inputPrompt.show ? '<input type="' + self.options.inputPrompt.type + '" ' + self.options.inputPrompt.attr + ' class="' + self.options.inputPrompt.class + '" name="response_string" value="' + self.options.inputPrompt.value + '" placeholder="' + self.options.inputPrompt.placeholder + '" title="' + self.options.inputPrompt.title + '" />' : '') +
				'</div>' +
				'<div class="modal-footer">' + buttonsArr.map(btn=>{
					btn = EBContext.utils.mergeObj(false, self.options.btnDefaults, btn);
					if(btn.show) return '<button type="submit" ' + btn.attr + ' name="response_'+btn.valueType+'" id="'+btn.idPrefix+'_'+this.uid+'" value="'+btn.value+'" class="' + btn.class + '" title="' + btn.title + '">' + btn.text + '</button>';
					return '';
				}).join('') + '</div>' +
				'</form>' :
				self.options.content) +
			'</div>' +
			'</div>' +
			'</div>'
		);
	}
	
	if (modalDOM instanceof NodeList) modalDOM = modalDOM[0];
	if (modalDOM) {
		modalDOM.setAttribute('data-modal-order', self.order);
		modalDOM.setAttribute('data-modal-uid', self.uid);
		var onModalShown = function (event) {
			if (self.options.onShown && typeof self.options.onShown === 'function') self.options.onShown(self);
			event.target.style.zIndex = (1040 + parseInt(event.target.getAttribute('data-modal-order'))*3+1);
			if (event.target.nextSibling) event.target.nextSibling.style.zIndex = (1040 + parseInt(event.target.getAttribute('data-modal-order'))*3);
			let firstFocusableEl = EBContext.utils.element.getFocusableChildren(event.target)[0];
			let firstFocusableCheckedSibling;
			if(firstFocusableEl && firstFocusableEl.form) firstFocusableCheckedSibling = firstFocusableEl.form.querySelector('[name="' + firstFocusableEl.name + '"]:checked');
			if(firstFocusableCheckedSibling) firstFocusableEl = firstFocusableCheckedSibling;
			if(firstFocusableEl) firstFocusableEl.focus();
			if(this.checkShownTimeout) clearTimeout(this.checkShownTimeout);
		};
		var onModalHide = function (event) {
			 // dle ARIA specifikace se nesm� na focusnut� element ani jeho p�edky nastavovat aria-hidden, co� se p�i skryt� nastavuje na popup
			if(event.target.contains(document.activeElement)) document.activeElement.blur();
			if('function' === typeof self.options.onHideCallback) self.options.onHideCallback();
		};
		var onModalHidden = function (event) {
			let bsModalObj = bootstrap.Modal.getInstance(event.target);
			if (event.target.getAttribute('disposable') !== null || self.options.disposable || self.options.disposeOnClose) {
				if(bsModalObj) bsModalObj.dispose();
				event.target.parentElement.removeChild(event.target);
				delete EBContext.instances.modalWindow[event.target.closest('[data-modal-uid]').getAttribute('data-modal-uid')];
			} else if(self.parentEl){
				if(document.contains(self.parentEl)){
					self.parentEl.appendChild(self.modalEl);
				} else { // ?? m� nastaven�ho parenta, ale ten u� nen� v DOM, tak popup zlikvidovat aby se p�i ajaxNav nehromadily na konci BODY
					if(self.modalEl && self.modalEl.parentElement) self.modalEl.parentElement.removeChild(self.modalEl);
				}
			}
		};
		self.modalEl = document.body.appendChild(modalDOM);
		let formEl = self.modalEl.querySelector('form');
		if(formEl) EBContext.utils.prepareForm(formEl);
		if(self.options.modal && self.options.btnCancel.show && !self.options.btnEsc.show){
			self.modalEl.addEventListener('keydown', e=>{
				if(e.key==='Escape'){
					let btnCancel = self.modalEl.querySelector('#btnCancel_'+self.uid);
					if(btnCancel) btnCancel.click();
				}
			});
		}
		self.modalObj = new bootstrap.Modal(self.modalEl, {
			show: true,
			backdrop: (self.options.modal ? 'static' : true),
			keyboard: !self.options.modal
		});
		self.modalEl.addEventListener('hide.bs.modal', onModalHide);
		self.modalEl.addEventListener('shown.bs.modal', onModalShown);
		self.modalEl.addEventListener('hidden.bs.modal', onModalHidden);
		self.modalId = this.id;
		self.open();
	}
	return this;
};
EBContext.modules.ModalBar = function(message, callback, options){
	this.options = EBContext.utils.extendObj(false, {
		heading: EBContext.utils.text.getHeading(message),
		position: 'bottom',
		btnOK: {
			show: true,
			text: '<i class="fas fa-fw va-2x fa-check"></i>',
			title: EBContext.resource('ACCEPT'),
			attr: '',
			class: 'btn btn-success',
			order: 0,
			value: true,
			idPrefix: 'btnOK'
		},
		btnCancel: {
			show: false,
			text: '<i class="fas fa-fw va-2x fa-times"></i>',
			title: EBContext.resource('CANCEL'), //'Zav��t',
			attr: '',
			class: 'btn btn-danger',
			order: 1,
			value: false,
			idPrefix: 'btnCancel'
		},
		btnDefaults: {
			show: true, text: '', title: '', attr: '', class: 'btn btn-primary',
			order: 2, value: 2, idPrefix: 'btn'
		},
		moreButtons: [],
		closeOnSubmit: true,
		disposeOnClose: true,
		callback: function (response, modal) {
			console.log(self.id + ': ' + response, modal);
		},
		fullwidth: true
	}, options);
	this.callback = callback || this.options.callback;
	this.order = Object.keys(EBContext.instances.modalBar).length;
	this.uid = 'b' + new Date().valueOf();
	this.id = this.options.modalId || 'modalBar_' + this.uid;
	this.path = 'EBContext.instances.modalBar.' + this.uid;
	EBContext.instances.modalBar[this.uid] = this;
	this.submitForm = function (form) {
		var formData = EBContext.utils.serializeForm(form, true);
		var resp = null;
		if (formData.hasOwnProperty('response_string')) {
			if (formData.response_boolean !== 'false') resp = formData.response_string;
		} else if(formData.hasOwnProperty('response_number')) {
			resp=parseFloat(formData.response_number);
		} else if(formData.hasOwnProperty('response_boolean')) {
			resp=(formData.response_boolean!=='false');
		} else if (formData.hasOwnProperty('btnOK')) {
			resp = true;
		} else {
			resp = false;
		}
		if(self.options.closeOnSubmit){
			self.close();
		}
		return self.callback(resp, self);
	};
	this.close = function(dispose){
		let barEl = document.getElementById(self.id);
		if(!barEl) return;
		barEl.style.display = 'none';
		if(dispose || (dispose === undefined && self.options.disposeOnClose)){
			barEl.parentElement.removeChild(barEl);
			delete EBContext.instances.modalBar[self.uid];
		}
		if('function' === typeof self.options.onHideCallback) self.options.onHideCallback();
	};
	this.open = function(){
		let barEl = document.getElementById(self.id);
		if(!barEl){
			buttonsArr = [self.options.btnOK,self.options.btnCancel].concat(self.options.moreButtons).sort((a,b)=>(a.order<b.order ? -1 : (a.order>b.order ? 1 : 0)));
			buttonsArr.forEach(btn=>{btn.valueType = btn.valueType || typeof btn.value});
			barEl = EBContext.utils.template('<div class="<!--$fullwidth--> d-print-none modal-bar g-0" data-modal-order="'+self.order+'" style="<!--~style-->" id="<!--$id-->"><form action="0" onsubmit="' + self.path + '.submitForm(this); return false;"><div class="row"><!--#message--><!--#buttons--></div></form></div>', {
				message: '<div class="col px-4 py-2"><!--$heading?#heading--><!--#text--></div>',
				heading: '<div class="h2"><!--$heading--></div>',
				text: '<div><!--$message--></div>',
				// buttons: '<div class="col-md-auto d-grid d-md-flex"><button type="submit" value="1" class="btn btn-primary px-5"><!--~resource.ACCEPT--></button></div>'
				buttons: '<div class="col-md-auto d-grid d-md-flex"><!--@getBtns--></div>'
			}, {
				id: self.id,
				heading: self.options.heading,
				message: message,
				style: (self.options.position === 'top' ? 'top:0;' : 'bottom:0;') + 'z-index:999;',
				fullwidth: (self.options.fullwidth ? 'container-fluid' : 'container fixed-centered'),
				buttonsArr: buttonsArr,
				getBtns: (vars, params, rootVars)=>{
					return rootVars.buttonsArr.map(btn=>{
						btn = EBContext.utils.mergeObj(false, self.options.btnDefaults, btn);
						if(btn.show) return '<button type="submit" ' + btn.attr + ' name="response_'+btn.valueType+'" id="'+btn.idPrefix+'_'+this.uid+'" value="'+btn.value+'" class="' + btn.class + '" title="' + btn.title + '">' + btn.text + '</button>';
						return '';
					}).join('');
				}
			})[0];
			document.body.appendChild(barEl);
			let formEl = barEl.querySelector('form');
			formEl.className='mb-0';
			if(formEl) EBContext.utils.prepareForm(formEl);
		}
		barEl.style.display='';
		this.barEl = barEl;
		return barEl;
	};
	var self = this;
	this.open();
	return this;
};
EBContext.modules.ResponsiveCollapse = function(collapseEl){
	var self = this;
	if(!collapseEl) return null;
	let existingInstance = Object.values(EBContext.instances.responsiveCollapse).find(rc=>rc.collapseEl===collapseEl);
	if(existingInstance){
		console.warn('%cInstance of ResponsiveCollapse for this element already exists!', EBContext.options.consoleStyles.warnMsg, existingInstance);
		return existingInstance;
	}
	this.collapseEl = collapseEl;
	this.breakpoint = collapseEl.getAttribute("data-collapse-breakpoint");
	if(!this.breakpoint) return null;
	this.openWidth = EBContext.utils.grid.getBreakpoints()[this.breakpoint];
	this.collapseInstance = bootstrap.Collapse.getInstance(this.collapseEl);
	this.state = 'default';
	this.lockState = false;
	this.uid = 'c' + new Date().valueOf();
	this.eventListeners = {};
	
	if(!this.collapseInstance) this.collapseInstance = new bootstrap.Collapse(this.collapseEl, {toggle: (window.innerWidth >= self.openWidth)});

	let showCallback = function (e) {
		let rc = Object.values(EBContext.instances.responsiveCollapse).find(c=>(c.collapseEl===e.currentTarget));
		if(!rc.lockState) rc.state = 'opened';
	};
	this.eventListeners.show = [this.collapseEl, 'show.bs.collapse', showCallback]; 
	this.collapseEl.addEventListener('show.bs.collapse', showCallback);
	
	let hideCallback = function (e) {
		let rc = Object.values(EBContext.instances.responsiveCollapse).find(c=>(c.collapseEl===e.currentTarget));
		if(!rc.lockState) rc.state = 'closed';
	};
	this.eventListeners.hide = [this.collapseEl, 'show.bs.collapse', hideCallback]; 
	this.collapseEl.addEventListener('hide.bs.collapse', hideCallback);
	
	this.check = function () {
		if(!document.body.contains(self.collapseEl)){
			Object.values(self.eventListeners).forEach(el=>el[0].removeEventListener(el[1], el[2]));
			delete EBContext.instances.responsiveCollapse[self.uid];
		} else if(self.state === 'default'){
			self.lockState = true;
			if(window.innerWidth >= self.openWidth){
				self.collapseInstance.show();
			} else {
				self.collapseInstance.hide();
			}
			self.lockState = false;
		}
	};
	this.eventListeners.resize = [window, 'resize', this.check]; 
	window.addEventListener('resize', this.check);
	
	EBContext.instances.responsiveCollapse[this.uid] = this;
	this.check();
	
	console.log('new ResponsiveCollapse: ', this);
	return this;
};


EBContext.modal = {
	get: (el)=>{
		let modalInstancesArr = (Object.values(EBContext.utils.getObj('EBContext.instances.modalWindow')) || []);
		let modal = modalInstancesArr.find(a=>EBContext.utils.element.getElement(el, a.modalEl) || a.id===el);
		if(!modal){
			el = EBContext.utils.element.getElement(el, document);
			if(el && !el.classList.contains('modal')) el = el.closest('.modal');
			modal = modalInstancesArr.find(a=>a.modalEl===el);
		}
		if(el && !modal){
			let uid = el.getAttribute('data-modal-uid');
			if(uid !== null) modal = EBContext.instances.modalWindow[uid];
		}
		return modal || null;
	},
	new: (...args)=>new EBContext.modules.ModalWindow(...args),
	bind: scope=>{
		scope = EBContext.utils.element.getScope(scope);
		[...scope.querySelectorAll('[data-popup]')].forEach(el=>{
			el.onclick = event=>{
				event.stopPropagation();
				event.preventDefault();
				let popupSrc = event.currentTarget.getAttribute('data-popup') || event.currentTarget.href;
				if(popupSrc && popupSrc.indexOf('http') !== 0 && '.#[/'.indexOf(popupSrc[0]) === -1){
					// fallback - p�vodn� se v data-popup podporovalo jen url nebo ID elementu bez #. Te� je tedy pot�eba na star� z�znamy # k selectoru doplnit.
					let popupEl = document.getElementById(popupSrc);
					if(popupEl) popupSrc = '#'+popupSrc;
				}
				if(popupSrc) EBContext.popup(popupSrc);
			};
		});
	},
	clear: (dispose)=>{
		for(var key in EBContext.instances.modalWindow){
			let modObj = EBContext.instances.modalWindow[key];
			modObj.modalEl.classList.remove("fade");
			modObj.close();
		}
		let fnDispose = ()=>{
			for(var key in EBContext.instances.modalWindow){
				let modObj = EBContext.instances.modalWindow[key];
				if(modObj.modalEl && modObj.modalEl.parentElement && !document.body.contains(modObj.modalEl.parentElement)) modObj.modalEl.parentElement.removeChild(modObj.modalEl);
				if(!modObj.modalEl || !modObj.modalEl.parentElement) delete EBContext.instances.modalWindow[key];
			}
		};
		if(dispose){
			fnDispose();
		} else {
			document.addEventListener('EBContext.ajaxNav.navigated', fnDispose, {once: true});
		}
		// @TODO - toto by m�la �e�it metoda zav�en� popupu, ale po reloadu Body nefunguje, tak je to pot�eba p�epsat i tady
		document.body.classList.remove('modal-open');
		document.body.style.paddingRight='';
		document.body.style.paddingLeft='';
		document.body.style.overflow='';
	}
};

/**
 * Function to act as asynchronous substitude for window.confirm
 * @param {String} message Message to be displayed in the popup window (statement to be confirmed or denied)
 * @param {EBContext.modules.Modal.callback} [callback] Callback that is called on submit of confirm
 * @param {Object} [options] object that merges into default options defining style, structure, controls and behavior of popup
 */
EBContext.confirm = function (message, callback, options) {
	return new EBContext.modules.ModalWindow(message, callback, options);
};

/**
 * Function to act as asynchronous substitude for window.alert
 * @param {String} message Message to be displayed in the popup window (statement to be acknowledged)
 * @param {EBContext.modules.Modal.callback} [callback] Callback that is called on submit of alert (`resp` is always `true`)
 * @param {Object} [options] object that merges into default options defining style, structure, controls and behavior of popup
 */
EBContext.alert = function (message, callback, options) {
	return new EBContext.modules.ModalWindow(message, callback, EBContext.utils.extendObj({
		btnCancel: {
			show: false
		}
	}, options));
};

/**
 * Function to act as asynchronous substitude for window.prompt
 * @param {String} message Message to be displayed in the popup window (question to be answered)
 * @param {EBContext.modules.Modal.callback} [callback] Callback that is called on submit of prompt (`resp` is value of prompt's input)
 * @param {Object} [options] object that merges into default options defining style, structure, controls and behavior of popup
 */
EBContext.prompt = function (message, callback, options) {
	return new EBContext.modules.ModalWindow(message, callback, EBContext.utils.extendObj({
		inputPrompt: {
			show: true
		}
	}, options));
};

/**
 * Function to asynchronously load page to a popup window
 * @param {String|Element} content URL of page to load
 * @param {Object} [options]
 */
EBContext.popup = function (content, options) {
	options = EBContext.utils.extendObj({
		post: null,
		reload: (EBContext.ajaxNav.options.defaultReload + ',').split(',')[0],
		modal: false,
		heading: '',
		modalId: null,
		callback: null
	}, options);

	var url = '';
	var wrapperId = '';
	var popupElement = null;
	if (content instanceof Element) {
		popupElement = content;
	} else if (typeof content === 'string') {
		if (content.indexOf('http') === 0 || content[0] === '/') {
			url = content;
			options.disposeOnClose=true;
			if(url[0] === '/' && EBContext.data.languageUrl && url.indexOf(EBContext.data.languageUrl) !== 0) url = EBContext.data.languageUrl + url;
			wrapperId = options.modalId || 'popup_' + new Date().valueOf();
			content = '';
			popupElement = EBContext.utils.template('<div class="ajaxWrapper"' + (options.disposeOnClose ? ' disposable' : '') + ' id="' + wrapperId + '"></div>')[0];
			document.body.appendChild(popupElement);
			EBContext.ajaxNav.ajaxCall(
				EBContext.utils.createAjaxURL(url, {
					reload: 'page:' + wrapperId
				}), 
				()=>{
					// console.log('popupElement: ', popupElement);
					popupElement = document.body.removeChild(popupElement); 
					modalEl = popupElement.querySelector('.modal');
					options.modal = modalEl.hasAttribute('data-ismodal');
					EBContext.popup(modalEl, options);
				}, 
				options.post,
				{loader: options.loader}
			);
			return null;
		} else {
			let popupObj = EBContext.modal.get(content);
			if(popupObj){
				popupObj.open();
				return popupObj;
			}
			popupElement = document.querySelector(content);
			options.modalId = options.modalId || (content[0] === '#' ? content.substr(1) : null);
		}
	}
	return new EBContext.modules.ModalWindow('', null, EBContext.utils.extendObj({
		content: content,
		popupElement: popupElement
	}, options));
};
EBContext.utils.setObj(EBContext, 'actions.popup', EBContext.popup);

/**
 * Add event listener on navigate to hide all modals when navigation occurs
 */
document.addEventListener('EBContext.ajaxNav.ready', EBContext.modal.bind);
document.addEventListener('EBContext.ajaxNav.navigate', EBContext.modal.clear);
document.addEventListener('EBContext.ajaxNav.bodyReload', ()=>EBContext.modal.clear(true));
document.addEventListener('EBContext.session.login', ()=>EBContext.modal.clear(true));
document.addEventListener('EBContext.session.logout', ()=>EBContext.modal.clear(true));